import { useCoreQuery } from "../../core/hooks/use-core-query.js";
import { useMenuAxios } from "../../core/context/axios.js";
import { MenuLink } from "../../core/components/menu-link.js";
import { markAllViewed } from "../../core/data/mutation.js";
import { Button, Loading } from "@tecsinapse/cortex-react";
import "react";
import { jsx, jsxs } from "react/jsx-runtime";
import { button } from "@tecsinapse/cortex-core";
import { useMutation } from "@tanstack/react-query";
import { Trans } from "@lingui/react";
//#region src/modules/notifications/components/footer.tsx
var Footer = ({ linkPortal }) => {
	const { instance } = useMenuAxios();
	const { mutateAsync, isPending } = useMutation({ mutationFn: () => markAllViewed(instance) });
	const { refetch } = useCoreQuery();
	const handleRead = async () => {
		try {
			await mutateAsync();
			await refetch();
		} catch (error) {
			console.error(error);
		}
	};
	return /* @__PURE__ */ jsxs("div", {
		className: "flex justify-between items-center p-mili gap-x-deca bg-white",
		children: [/* @__PURE__ */ jsx(MenuLink, {
			to: "/notificacoes",
			className: button({ className: "flex-1 no-underline !text-on-primary hover:!text-on-primary visited:!text-on-primary" }),
			linkPortal,
			children: /* @__PURE__ */ jsx(Trans, { id: "8b7AZk" })
		}), /* @__PURE__ */ jsxs(Button, {
			variants: {
				className: "flex-1",
				variant: "outline"
			},
			onClick: handleRead,
			disabled: isPending,
			children: [isPending ? /* @__PURE__ */ jsx(Loading, {}) : null, /* @__PURE__ */ jsx(Trans, { id: "Oe3qd7" })]
		})]
	});
};
//#endregion
export { Footer };
